module.exports = __webpack_public_path__ + "static/media/LinkedIn.15b4954e.svg";